import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"
import { getCurrentUser, setCurrentUser } from "./Utils"
import Loader from "../components/Loader/loader"
import store from "../store"

//pass new generated access token here
const token = accessToken

//apply base url for axios
const API_URL = ""

const axiosApi = axios.create({
  baseURL: API_URL,
})
axiosApi.defaults.headers.common["Authorization"] = token

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
export async function DashboardData(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}
export async function getWithParams(url, params, config = {}) {
  return await axiosApi
    .get(url, { params, ...config })
    .then(response => response.data)
}

export const leadDisplay = async ({
  navigate,
  e,
  value,
  branch,
  dateFilter,
  setLoader,
  setAllLeads,
  setReminders,
  setMatureStages,
  setFollowUps,
  setLeadLabels,
  setPermission,
  setDatabaseSize,
  setConvertedTime,
  setLoading,
  setCompanyPoolCount,
}) => {
  setLoader(<Loader />)

  let url
  const branchQuery = branch !== "" ? `&branch_id=${branch}` : ""

  if (e !== undefined) {
    url = `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
      "company_name"
    )}/dashboard-data?from_date=${formatDate(
      dateFilter[0].startDate
    )}&to_date=${formatDate(dateFilter[0].endDate)}&leadholder_id=${
      value.leadholder_id
    }&created_by=${value.createdBy_id}${branchQuery}`
  } else {
    url = `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
      "company_name"
    )}/dashboard-data?${branchQuery}`
  }

  try {
    const res = await axios.get(url, {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${getCurrentUser().token || ""}`,
      },
    })

    const data = res.data.data
    setLoader("")
    setAllLeads(data?.dashboard)
    if (typeof setCompanyPoolCount === "function") {
      setCompanyPoolCount(
        data?.company_pool?.count ?? data?.all_counters?.company_pool ?? 0
      )
    }
    setReminders(data?.reminders)
    setMatureStages(data?.mature_status)
    setFollowUps(data?.followup_statuses)
    setLeadLabels(data?.labels)
    setPermission(data?.permissions)
    setDatabaseSize(data?.db_usage)
 store.dispatch({ type: "SET_API_RESPONSE", payload: data?.all_counters });
    localStorage.setItem("LastUpdated", new Date().getTime())
    localStorage.setItem("DashboardData", JSON.stringify(data))
    localStorage.setItem("NavCounters", JSON.stringify(data?.all_counters))
    localStorage.setItem("AllSource", JSON.stringify(data?.sources))
    localStorage.setItem(
      "AllFollowups",
      JSON.stringify(data?.followup_statuses)
    )
    localStorage.setItem("MatureStages", JSON.stringify(data?.mature_status))
    localStorage.setItem("AllLabels", JSON.stringify(data?.labels))
    localStorage.setItem("AllTags", JSON.stringify(data?.tag))
    localStorage.setItem("All-User", JSON.stringify(data?.users))
    localStorage.setItem("AllUsers", JSON.stringify(data?.lead_holders))
    localStorage.setItem("NextFollowup", JSON.stringify(data?.next_followup))
    localStorage.setItem("Noti-Count", data?.notification_count)

    setLoading(false)

    const storedTime = new Date()
    const currentTime = new Date()
    const differenceInMinutes = Math.floor(
      (currentTime - storedTime) / (1000 * 60)
    )
    setConvertedTime(differenceInMinutes)
  } catch (error) {
    if (error.response) {
      if (error.response.status === 401) {
        setCurrentUser("")
        localStorage.setItem("DashboardData", "")
        localStorage.setItem("LastUpdated", "")
        localStorage.setItem("NavCounters", "")
        history.push("/login")
      }
    } else if (error.request) {
      console.log("No response received", error.request)
      setCurrentUser("")
      localStorage.setItem("DashboardData", "")
      localStorage.setItem("LastUpdated", "")
      localStorage.setItem("NavCounters", "")
      history.push("/login")
    } else {
      console.log("Error:", error.message)
    }
    setLoader("")
    setLoading(false)
  }
}
